// Shop-canonical timezone for product-context-free calendar values (URL filters, datepicker
// boundaries, "today" labels) and the fallback when a GraphQL LocalDate.timezone is absent.
export const DEFAULT_TIME_ZONE = 'Europe/Berlin'
